// (function () {
//   document.addEventListener(
//     "click",
//     async function (e) {
//       const btn = e.target.closest(".quick-buy-now");
//       if (!btn) return;

//       const variantId = btn.getAttribute("data-variant-id");
//       if (!variantId) return;

//       btn.disabled = true;

//       try {
//         await fetch("/cart/add.js", {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//             Accept: "application/json",
//           },
//           body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
//         });

//         window.location.href = "/checkout";
//       } catch (err) {
//         const form = btn.closest("form");
//         if (form) form.submit();
//       } finally {
//         btn.disabled = false;
//       }
//     },
//     { passive: true }
//   );
// })();

// assets/buy-now.js
(function () {
  document.addEventListener(
    "click",
    async function (e) {
      const btn = e.target.closest(".quick-buy-now");
      if (!btn) return;

      // Try to find the product form (product page / quick view)
      const wrapper =
        btn.closest("product-form") ||
        btn.closest(".product, .quick-add-modal, .product-section") ||
        document;
      const form =
        wrapper.querySelector('form[data-type="add-to-cart-form"]') ||
        wrapper.querySelector('form[action*="/cart/add"]');

      btn.disabled = true;

      try {
        if (form) {
          // PRODUCT PAGE FLOW: use the form's current state
          const fd = new FormData(form);

          // Ensure variant id is set (hidden input) or fall back to data-variant-id on the button
          if (!fd.get("id")) {
            const btnVariant = btn.getAttribute("data-variant-id");
            if (btnVariant) fd.set("id", btnVariant);
          }

          // Ensure quantity is present; if the qty input is outside the <form>, grab it from the wrapper
          if (!fd.get("quantity")) {
            const qtyEl =
              wrapper.querySelector('input[name="quantity"], select[name="quantity"]');
            fd.set("quantity", qtyEl && qtyEl.value ? qtyEl.value : 1);
          }

          // Optional: clamp to min/step if you use quantity rules
          const qtyInput = wrapper.querySelector('input[name="quantity"]');
          if (qtyInput) {
            const min = parseInt(qtyInput.min || "1", 10);
            const step = parseInt(qtyInput.step || "1", 10);
            let q = parseInt(fd.get("quantity"), 10) || 1;
            if (q < min) q = min;
            if (step > 1 && q % step !== 0) q = Math.ceil(q / step) * step;
            fd.set("quantity", q);
          }

          // Add to cart with all current form fields (properties, selling_plan, gift card recipient, etc.)
          const res = await fetch("/cart/add.js", {
            method: "POST",
            headers: { Accept: "application/json" },
            body: fd
          });

          if (!res.ok) {
            const err = await res.json().catch(() => ({}));
            throw new Error(err.description || "Could not add to cart");
          }
        } else {
          // COLLECTION CARD FALLBACK: use data-variant-id and quantity:1
          const variantId = btn.getAttribute("data-variant-id");
          if (!variantId) throw new Error("Missing variant id");
          const res = await fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json"
            },
            body: JSON.stringify({ id: Number(variantId), quantity: 1 })
          });
          if (!res.ok) {
            const err = await res.json().catch(() => ({}));
            throw new Error(err.description || "Could not add to cart");
          }
        }

        // Go straight to checkout
        window.location.href = "/checkout";
      } catch (err) {
        // Show theme error if available; otherwise fail open to default submit
        const errWrap = wrapper.querySelector(".product-form__error-message-wrapper");
        const errMsg = wrapper.querySelector(".product-form__error-message");
        if (errWrap && errMsg) {
          errMsg.textContent = err.message;
          errWrap.hidden = false;
        } else {
          // If there's a real <form>, let it submit normally as a fallback
          if (form) form.submit();
          else alert(err.message);
        }
      } finally {
        btn.disabled = false;
      }
    },
    { passive: true }
  );
})();
